module.exports = __webpack_public_path__ + "static/media/plasma.e3246cfd.png";